import FourOhFour from './FourOhFour';

export default FourOhFour;
